import type { InternalAxiosRequestConfig, AxiosResponse, AxiosError } from 'axios';

import { HttpClient as BffHttpClient } from './bff-sdk';
import { HttpClient as BookingRequestHttpClient } from './booking-request-sdk';
import { HttpClient as DotnetHttpClient } from './dotnet-sdk';

// interceptor that adds a correlation id every request
const interceptor = (config: InternalAxiosRequestConfig) => {
  const correlationId = crypto.randomUUID();
  config.headers['correlation-id'] = correlationId;
  return config;
};

// response interceptor to handle specific error cases
const responseInterceptor = (response: AxiosResponse) => {
  return response;
};

const errorInterceptor = (error: AxiosError) => {
  if (error.response?.status === 503) {
    console.error('503 Service Unavailable Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      message: (error.response?.data as { message?: string })?.message,
      timestamp: new Date().toISOString(),
    });
  }

  return Promise.reject(error);
};

export const getServerHttpClient = (req: Request) => {
  const httpClient = new BffHttpClient({
    baseURL: ENV.API_URL,
    withCredentials: true,
    headers: {
      Cookie: req.headers.get('cookie') || '', // Cookies from request header
    },
  });

  // attach interceptor to request
  httpClient.instance.interceptors.request.use(interceptor);
  httpClient.instance.interceptors.response.use(responseInterceptor, errorInterceptor);

  return httpClient;
};

const clientHttpClient = new BffHttpClient({
  baseURL: ENV.API_URL,
  withCredentials: true,
});

clientHttpClient.instance.interceptors.request.use(interceptor);
clientHttpClient.instance.interceptors.response.use(responseInterceptor, errorInterceptor);

const dotnetHttpClient = new DotnetHttpClient({
  baseURL: `${ENV.API_URL}/v1/booking`,
  withCredentials: true,
});

dotnetHttpClient.instance.interceptors.request.use(interceptor);
dotnetHttpClient.instance.interceptors.response.use(responseInterceptor, errorInterceptor);

const bookingRequestHttpClient = new BookingRequestHttpClient({
  baseURL: `${ENV.API_URL}/v1/booking-request`,
  withCredentials: true,
});

bookingRequestHttpClient.instance.interceptors.request.use(interceptor);
bookingRequestHttpClient.instance.interceptors.response.use(responseInterceptor, errorInterceptor);

export { clientHttpClient, dotnetHttpClient, bookingRequestHttpClient };
